$('.main-menu').on('click', 'a', function (e) {
    if ($(this).next().is('ul, div')) {
        e.preventDefault();
    }
    if ($(window).width() < 768) {
        if ($(this).parent().parent().is('.main-menu')) {
            if ($(this).parent().parent('.main-menu').find('ul').is(':visible')) {
                $(this).next().slideUp();
                $('.main-menu_drop_sub').find('ul').slideUp();
                $(this).parent().parent('.main-menu').find('a').removeClass('open');
            } else {
                $(this).next().slideDown();
                $(this).addClass('open');
            }
        } else {
            $(this).toggleClass('open');
            $(this).next().slideToggle();
        }
    }
});

for (let link of $('.main-menu').find('a')){
    if($(link).next().is('ul, div')){
        $(link).append('<span></span>').addClass('drop');
    }
}


// WEBPACK FOOTER //
// ./css/bem/header/menu/_menu.js